import React from 'react';
import Poll from "../../../components/pages/form/Poll/Poll";

const PollPage = () => {
    return <Poll />
};

export default PollPage;